import jQuery from 'jquery';

const $ = jQuery;

const initMenuIcon = () => {
  const contactIcon = $('.contact-menu');
  const linkDescription = $('.link-description .mega-menu-link');
  const buttonLink = $('.button-link a[title="main-link"]');
  const menuTitle = $('.remove-link a.mega-menu-link');
  const url = window.location.pathname;
  const urlRegExp = new RegExp(url.replace(/\/$/,''));    

  $(contactIcon).append(
    '<svg class="icon icon-telephone" aria-hidden="true"><use xlink:href="#icon-telephone"></use></svg>',
  );

  $(linkDescription).each(function(){
    var title = $(this).attr('title');
    $(this).append('<span class="menu-link">'+title+'<svg class="icon icon-menu-arrow" aria-hidden="true"><use xlink:href="#icon-menu-arrow"></use></svg></span>');
  });

  $(buttonLink).each(function(){
    var icon = $(this).find('span.mega-indicator');

    $(icon).removeAttr('tabindex').removeAttr('role').removeAttr('aria-label');
    $(this).removeAttr('aria-haspopup').removeAttr('tabindex').removeAttr('href');
    $(this).replaceWith($('<button class="mega-menu-link" title="main-link" expanded="false">' + this.innerHTML + '</button>'));
  });

  $('button.mega-menu-link').on('click', function() {
    $('.mega-menu-item-has-children').removeClass('mega-toggle-on');
    $(this).parent().addClass('mega-toggle-on');
  });

  $(menuTitle).each(function(){
    var title = $(this).text();
    $(this).replaceWith('<span class="mega-menu-link">' + title + '</span>');
  });

  $('header a').each(function(){
    if (window.location.pathname !== '/') {
      if (urlRegExp.test(this.href)) {
        $(this).addClass('current-menu-item');
        $(this).parent('li').addClass('mega-current-menu-item');
        
        let parent_id = $('.mega-current-menu-item').attr('data-parent-menu');
        $('li[data-menu="' + parent_id + '"]').addClass('mega-current-menu-parent');
      }
    }
  });

  $('.mobile-toggle').on('click', function(){
    setTimeout(
      function(){
        if ($('.mega-menu-toggle').hasClass('mega-menu-open')) {
          $('.additional-menu').addClass('menu-open');
        } else {
          $('.additional-menu').removeClass('menu-open');
        }
      },
      100
    );
  });
};

export default initMenuIcon;